module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-gallery"
  }, [_c('StartPageSlider', {
    attrs: {
      "line-title-color": "#F01F51",
      "title": "организации"
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "logo-card",
      on: {
        "click": function($event) {
          return _vm.click(item.organizationId)
        }
      }
    }, [_c('div', {
      staticClass: "logo-card_logo"
    }, [_c('AppPicture', {
      attrs: {
        "image": item.imageUrl
      }
    })], 1), _c('div', {
      staticClass: "logo-card_info"
    }, [_c('span', {
      staticClass: "logo-card_info__title ui_lines-limit-3"
    }, [_vm._v(_vm._s(item.title))])])])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-adcb6de8","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/components/sections/logo/Logos.vue
// module id = 0482ec22b20660898bb6
// module chunks = 0